import React, {useContext, useEffect} from 'react';
import HeaderSI from './HeaderSI';
import LoginContext from '../../context/UserContext';
import barra_colores from './../../../src/assets/img/barra_colores.png';
import { useLocation } from 'react-router-dom';

export default function () {
  const { first_name, loadingAuthentication, token } = useContext(LoginContext);
  // console.log('log', loadingAuthentication);
  const location = useLocation();
  const returnUrl = `https://somosintercorp.net/Account/Login?ReturnUrl=https://entrenate.ucic.pe${location.pathname}`;
  // console.log('location', location.pathname, location.pathname.startsWith('/gdh'));

  // Obtener el referrer y los dominios permitidos
  // const referrer = document.referrer;
  // const allowedReferrers = [
  //   'somosintercorp.net',
  //   'enterate.somosintercorp.net',
  //   'crece.somosintercorp.net',
  //   'contribuye.ucic.pe',
  //   'beneficiate.somosintercorp.net'
  // ];

  // Verificar si el referrer es uno de los permitidos
  // const isAllowedReferrer = allowedReferrers.some(domain => referrer.includes(domain));

  // Redirigir a somosintercorp.net si no hay token en contexto, el referrer no es permitido
  // if (!token && !isAllowedReferrer) {
  //   window.location.replace(returnUrl);
  //   return null; // Detener la renderización para evitar errores de render
  // }

  return (
    <div className='headers'>
      {(location.pathname.startsWith('/gdh') || location.pathname.startsWith('/homeibs')) ? (
        <HeaderSI first_name={first_name} token={token} />
      ) : (
        first_name ?
          <HeaderSI first_name={first_name} token={token} /> :
          loadingAuthentication ? null :
            window.location.replace(returnUrl))
      }
      <img src={barra_colores} alt='Barra de colores' className='w-100 h-25 barra_colores' />
    </div>
  );
}
